import type { IHeadersConfigs } from '../models';

export const headers: IHeadersConfigs = {
    h1: {
        fontSize: 48,
        lineHeight: 1.2,
    },
    h2: {
        fontSize: 40,
        lineHeight: 1.2,
    },
    h3: {
        fontSize: 30,
        lineHeight: 1.2,
    },
    h4: {
        fontSize: 24,
        lineHeight: 1.2,
    },
    h5: {
        fontSize: 18,
        lineHeight: 1.3,
    },
};
